/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CLOSE_BTN, DELETE, LINE_GUILD_GRADIENT, TWO_LINE } from 'assets/images'
import { Modal } from 'shared'
import { GUILD_MESSAGE, PROFILE_MESSAGE } from 'i18n/constants'
import ModalSetRewardTemplateStyled from './styled'
import SelectCustomCreateRace from 'shared/SelectCustomCreateRace'
import { NUMBER } from 'apps/constants'
import { getImgByKey, getOnlyDecimal, handleAsyncRequest, truncateDecimal } from 'utils/helper'
import { GetRaceListParams, RaceStatus } from 'models'
import { useAppSelector } from 'hooks'
import InputPrizePool from 'shared/InputPrizePool'
import Button from 'shared/Button'
import guildApi from 'apis/guildApi'
import ChooseMoreItemReward from '../ChooseMoreItemReward'
import { notification } from 'antd'
import SelectCustomGuildRace from 'shared/SelectCustomGuildRace'
import { BigNumber } from 'bignumber.js'
import Loading from 'features/Guild/pages/Loading'

interface Props {
  onCloseButtonClick: () => void
  handleSaveSetReward: (values: any) => void
  finalDataRoot: any
  setFinalDataRoot: (values: any) => void
  finalData: any
  setFinalData: (values: any) => void
  maxHorse?: number | string
  tempClear: any
  setTempClear: (values: any) => void
}

const defaultParams: GetRaceListParams = {
  limit: NUMBER.TWENTY_FOUR,
  page: NUMBER.ONE,
  status: RaceStatus.OPEN,
  active: '1'
}

function ModalSetRewardTemplate(props: Props) {
  const { onCloseButtonClick, handleSaveSetReward, setFinalDataRoot, finalData, setFinalData, maxHorse, setTempClear } = props
  const [isLoading, setIsLoading] = useState(true)
  const { t } = useTranslation()
  const { profile } = useAppSelector(state => state)
  const [params] = useState<GetRaceListParams>(defaultParams)
  const [isLoadingApply, setIsLoadingApply] = useState(false)
  const [isNotPassApply, setIsNotPassApply] = useState(false)
  const [rankingFilters] = useState(() => {
    const ordinalSuffix = (n: number) => {
      if (n === 1) return '1st'
      if (n === 2) return '2nd'
      if (n === 3) return '3rd'
      return `${n}th`
    }

    const values = Array.from({ length: Number(maxHorse) }, (_, i) => {
      const rank = i + 1
      return {
        name: ordinalSuffix(rank),
        isActive: false,
        value: ordinalSuffix(rank).toUpperCase()
      }
    })

    return values
  })
  const [templateFilters, setTemplateFilters] = useState([])
  const [ranking, setRanking] = useState(rankingFilters?.at(0)?.name)
  const [template, setTemplate] = useState('')
  const [packageId, setPackageId] = useState<number>(0)
  const [itemsRenderByRank, setItemsRenderByRank] = useState<any[]>([])
  const [optionItemType, setOptionItemType] = useState<any[]>([])
  const [showChooseMoreItem, setShowChooseMoreItem] = useState({
    isShow: false,
    type: '',
    id: 0
  })
  const [coinStore, setCoinStore] = useState([])
  const [ticketStore, setTicketStore] = useState([])
  const [boosterStore, setBoosterStore] = useState([])
  const [imgNonNftList, setImgNonNftList] = useState<any>({})
  const [optionsName, setOptionsName] = useState([])

  useEffect(() => {
    if (profile?.guild_id) {
      const handleGetStore = async () => {
        try {
          const [coinRes, ticketRes, boosterRes, dopingRes, energyRes]: any = await Promise.all([
            handleAsyncRequest(
              guildApi.getVaultCoinReward(profile.guild_id, { ...params })
            ),
            handleAsyncRequest(
              guildApi.getVaultTicketReward(profile.guild_id, { ...params })
            ),
            handleAsyncRequest(
              guildApi.getVaultNonNftReward(profile.guild_id, { ...params, limit: 40 })
            ),
            handleAsyncRequest(guildApi.getOptionItemNameV2("DOPING")),
            handleAsyncRequest(guildApi.getOptionItemNameV2("ENERGY")),
          ])

          const [, coinResult] = coinRes
          const [, ticketResult] = ticketRes
          const [, boosterResult] = boosterRes
          const [, dopingResult] = dopingRes
          const [, energyResult] = energyRes

          setCoinStore(coinResult?.data?.records)
          setTicketStore(ticketResult?.data?.records)
          setBoosterStore(boosterResult?.data?.records)
          const upperCaseData = Object.fromEntries(
            Object.entries({
            ...dopingResult?.data,
            ...energyResult?.data,
          }).map(([key, value]) => [key.toUpperCase(), value])
          )
          setImgNonNftList(upperCaseData);
        } finally {
          setIsLoading(false)
        }
      }
      handleGetStore()
    }
  }, [profile?.guild_id])


  const optionsCoin = useMemo(() => {
    let amountAdilUsed = 0
    let amountKudaUsed = 0
    let amountMerahUsed = 0
    if (finalData) {
      const coinUsed = Object.values(finalData)
      coinUsed.forEach((coin: any) => {
        coin.items.forEach((itm: any) => {
          if (itm.coin_type === 'ADIL') {
            amountAdilUsed += Number(itm.amount)
          }
          if (itm.coin_type === 'KUDA') {
            amountKudaUsed += Number(itm.amount)
          }
          if (itm.coin_type === 'MERAH') {
            amountMerahUsed += Number(itm.amount)
          }
        })
      })
    }
    const result = coinStore.filter((coin: any) => {
      const inStore = coin.quantity - coin.in_use
      if (coin.coin_type === 'ADIL') {
        return inStore > 0 && inStore > amountAdilUsed
      }
      if (coin.coin_type === 'KUDA_NEW') {
        return inStore > 0 && inStore > amountKudaUsed
      }
      if (coin.coin_type === 'MERAH_NEW') {
        return inStore > 0 && inStore > amountMerahUsed
      }
    })
    return result.map((res: any) => ({
      isAcitve: false,
      name: res.coin_type.replace('_NEW', ''),
      icon: <img className='mr-2' alt='Merah' src={getImgByKey(res.coin_type)} width={25} />,
      inStore: Number(truncateDecimal(new BigNumber(res.quantity).minus(res.in_use).toNumber())),
    }))
  }, [coinStore, finalData])

  const optionsTicket = useMemo(() => {
    let amountSilverUsed = 0
    let amountGoldUsed = 0
    if (finalData) {
      const ticketUsed = Object.values(finalData)
      ticketUsed.forEach((coin: any) => {
        coin.items.forEach((itm: any) => {
          if (itm.coin_type === 'GOLD') {
            amountGoldUsed += Number(itm.amount)
          }
          if (itm.coin_type === 'SILVER') {
            amountSilverUsed += Number(itm.amount)
          }
        })
      })
    }
    const result = ticketStore.filter((ticket: any) => {
      const inStore = ticket.quantity - ticket.in_use
      if (ticket.ticket_type === 'GOLD') {
        return inStore > 0 && inStore > amountGoldUsed
      }
      if (ticket.ticket_type === 'SILVER') {
        return inStore > 0 && inStore > amountSilverUsed
      }
    })
    return result.map((res: any) => ({
      isAcitve: false,
      name: res.ticket_type,
      icon: <img className='mr-2' alt='Merah' src={getImgByKey(res.ticket_type)} width={25} />,
      inStore: res.quantity - res.in_use,
    }))
  }, [ticketStore, finalData])

  const getCoinAvailableInStore = (coin_type: any) => {
    const coinSelected: any = coinStore.find(
      (coin: any) => coin.coin_type?.replace('_NEW', '')?.toUpperCase() === coin_type?.toUpperCase()
    )
    if (!coinSelected) {
      return 0
    }
    return coinSelected?.quantity - coinSelected?.in_use
  }

  const getTicketAvailableInStore = (ticket_type: any) => {
    const ticketSelected: any = ticketStore.find((ticket: any) => ticket.ticket_type === ticket_type)
    if (!ticketSelected) {
      return 0
    }
    return ticketSelected?.quantity - ticketSelected?.in_use
  }

  const getBoosterAvailableInStore = (name: any) => {
    const boosterSelected: any = boosterStore.find(
      (booster: any) => booster.name?.toUpperCase() === name?.toUpperCase()
    )
    if (!boosterSelected) {
      return 0
    }
    return boosterSelected?.quantity - boosterSelected?.in_use
  }

  const randomId = (min = 1_000_000_000_000, max = 9_999_999_999_999) => {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  const showToastError = (message: string) => {
    notification.error({
      message: 'ERROR',
      description: message ?? 'Error',
      placement: 'bottomRight',
      duration: 4,
      className: 'ant-custom-error',
      icon: <></>
    })
  }

  const itemTypeConvertedName = (value: string) => {
    switch (value) {
      case 'NFT':
        return t(`${GUILD_MESSAGE}.nftItems`)
      case 'NON_NFT':
        return t(`${GUILD_MESSAGE}.nonNftItems`)
      case 'COIN':
        return t(`${GUILD_MESSAGE}.coin`)
      case 'NFT_TICKET':
        return t(`${GUILD_MESSAGE}.nftTicket`)
      default:
        return ''
    }
  }

  const isDisabledSave = useMemo(() => {
    if (!finalData) return false
    return Object.values(finalData).some((data: any) =>
      data?.items?.some((item: any) => item.isError || Number(item.amount) === 0)
    )
  }, [finalData])

  useEffect(() => {
    const fetchOptionItemType = async () => {
      const [error, result]: any = await handleAsyncRequest(guildApi.getOptionItemType())
      if (error) {
        return
      }
      if (result) {
        const order = ['NFT', 'NFT_TICKET', 'NON_NFT', 'COIN']
        const sorted: string[] = [...result.data].sort((a, b) => order.indexOf(a) - order.indexOf(b))
        setOptionItemType(() =>
          sorted?.map((opt: string) => ({
            name: itemTypeConvertedName(opt),
            isActive: false,
            value: opt
          }))
        )
      }
    }
    fetchOptionItemType?.()
  }, [])

  useEffect(() => {
    if (isNotPassApply) {
      setItemsRenderByRank([])
      setIsNotPassApply(false)
    }
  }, [isNotPassApply])

  useEffect(() => {
    setItemsRenderByRank(finalData?.[ranking as string]?.items ?? [])
    setPackageId(finalData?.[ranking as string]?.packageId ?? 0)
    setTemplate(finalData?.[ranking as string]?.template ?? '')
  }, [ranking])

  useEffect(() => {
    if (profile.guild_id !== NUMBER.ZERO) {
      getListGuildRewardSetting()
    }
  }, [params, profile])

  const asyncFinalData = (key: string, value: any) => {
    setFinalData({
      ...finalData,
      [key]: value
    })
  }

  const getListGuildRewardSetting = async () => {
    const [error, result]: any = await handleAsyncRequest(
      guildApi.getGuildRewardSetting(profile.guild_id, { limit: NUMBER.TWENTY_FOUR, page: NUMBER.ONE })
    )
    if (error) {
      return
    }
    if (result) {
      const formatData = result.data.records.map((record: any) => {
        return {
          name: record.package_code,
          isActive: false,
          value: record.package_code,
          id: record.id
        }
      })
      setTemplateFilters(formatData)
    }
  }

  const getPackageInRepository = async (item: any) => {
    try {
      const [error, result]: any = await handleAsyncRequest(
        ['HEAD', 'BODY', 'LEG', 'SKIN'].includes(item.item_type)
          ? guildApi.getVaultItems(profile.guild_id, {
              ...params,
              rarity: item.rarity_type,
              type: item.item_type,
              setName: item.parent_sub_type
            })
          : item.item_type === 'COIN'
          ? guildApi.getVaultCoinReward(profile.guild_id, { ...params })
          : item.item_type === 'BOOSTER'
          ? guildApi.getVaultNonNftReward(profile.guild_id, { ...params })
          : guildApi.getVaultTicketReward(profile.guild_id, { ...params }) // TICKET
      )
      if (error) {
        return null
      }
      if (result) {
        return result.data
      }
    } catch (err) {
      return null
    }
  }

  const getImgByApiKey = async (type: string, key: string) => {
    if (type === 'COIN') {
      //
    } else if (type === 'TICKET') {
      //
    } else {
      return imgNonNftList?.[key]
    }
  }

  // const randomItems = (arr: any[], count: number) => {
  //   return [...arr].sort(() => Math.random() - 0.5).slice(0, count)
  // }

  const handleApply = async () => {
    setIsLoadingApply(true)
    const finalDataNotCurrentRanking = finalData
      ? Object.fromEntries(Object.entries(finalData)?.filter(([key]) => key !== ranking))
      : []
    const [error, result]: any = await handleAsyncRequest(guildApi.getGuildRewardSettingDetail(packageId))
    if (error) {
      setIsLoadingApply(false)
      return
    }
    if (result) {
      const packageList = result.data?.rewards_package_dto_list
      if (packageList?.length) {
        const results = await Promise.all(packageList.map(getPackageInRepository))
        if (results?.length) {
          const itemsApply = []
          const listIdsCurrentRanking: any = []
          for (let i = 0; i < packageList?.length; i++) {
            const recordsByIndex = results[i]?.records
            if (packageList[i]?.item_type === 'COIN') {
              const coinResult = recordsByIndex?.find(
                (item: any) => item.coin_type?.toUpperCase() === packageList[i]?.parent_sub_type?.toUpperCase()
              )
              const item: any = {
                idRandom: randomId(),
                amount: packageList[i]?.amount,
                coin_type: packageList[i]?.parent_sub_type?.replace('_NEW', ''),
                type: 'COIN',
                inStore: coinResult ? coinResult?.quantity - coinResult?.in_use : 0,
                status: 'DRAFT',
              }
              // Amount item === name => in current template
              let amountInCurrentTemplate = 0
              if (i > 0) {
                const slicedItems = packageList.slice(0, i)
                const listItems = slicedItems.filter((it: any) => it.parent_sub_type === packageList[i]?.parent_sub_type)
                amountInCurrentTemplate = listItems.reduce(
                  (sum: number, item: any) => sum + (item.amount ?? 0),
                  0
                )
              }
              const isPass = Number(item.inStore) >= packageList[i]?.amount + amountInCurrentTemplate
              if (!isPass) {
                item.isError = true
                // const isExis = coinStore.some(
                //   (coin: any) => coin.coin_type === packageList[i]?.parent_sub_type && coin.quantity > coin.in_use
                // )
                // if (!isExis) {
                //   item.amount = ''
                //   item.coin_type = ''
                //   item.icon = ''
                // }
              }
              // Check all ranking
              const quantityInStore = Number(item.inStore)
              let quantityNftUsed = 0
              Object.values(finalDataNotCurrentRanking)?.forEach((data: any) => {
                data?.items?.forEach((item: any) => {
                  if (
                    item.type === 'COIN' &&
                    item.coin_type?.replace('_NEW', '')?.toUpperCase() ===
                      coinResult?.coin_type?.replace('_NEW', '')?.toUpperCase()
                  ) {
                    quantityNftUsed += Number(item.amount)
                  }
                })
              })
              if (quantityNftUsed + packageList[i]?.amount + amountInCurrentTemplate > quantityInStore) {
                item.isError = true
                // const isExis = coinStore.some(
                //   (coin: any) => coin.coin_type === packageList[i]?.parent_sub_type && coin.quantity > coin.in_use
                // )
                // if (!isExis) {
                //   item.amount = ''
                //   item.coin_type = ''
                //   item.icon = ''
                // }
              }
              itemsApply.push(item)
            }
            if (packageList[i]?.item_type === 'BOOSTER') {
              const boosterResult = recordsByIndex?.find(
                (item: any) => item.name?.toUpperCase() === packageList[i]?.designated_item?.toUpperCase()
              )
              const item: any = {
                idRandom: randomId(),
                id: boosterResult?.booster_id ?? randomId(),
                isError: !boosterResult?.booster_id ? true : false,
                amount: packageList[i]?.amount,
                coin_type: boosterResult ? boosterResult?.name : packageList[i]?.designated_item,
                type: 'NON_NFT',
                icon: boosterResult ? boosterResult?.img : await getImgByApiKey(packageList[i]?.parent_sub_type, packageList[i]?.designated_item?.toUpperCase()),
                inStore: boosterResult ? Number(boosterResult?.quantity - boosterResult?.in_use) : 0,
                status: 'DRAFT',
              }
              // Amount item === name => in current template
              let amountInCurrentTemplate = 0
              if (i > 0) {
                const slicedItems = packageList.slice(0, i)
                const listItems = slicedItems.filter((it: any) => it.designated_item === packageList[i]?.designated_item)
                amountInCurrentTemplate = listItems.reduce(
                  (sum: number, item: any) => sum + (item.amount ?? 0),
                  0
                )
              }
              const isPass = Number(item.inStore) >= packageList[i]?.amount + amountInCurrentTemplate
              if (!isPass) {
                item.isError = true
                // item.amount = ''
                // item.coin_type = ''
                // item.icon = ''
              }
              // Check all ranking
              const quantityInStore = Number(item.inStore)
              let quantityNftUsed = 0
              Object.values(finalDataNotCurrentRanking)?.forEach((data: any) => {
                data?.items?.forEach((item: any) => {
                  if (
                    item.coin_type?.toUpperCase() === boosterResult?.name?.toUpperCase() &&
                    (item.type === 'NON_NFT' || item.type === 'NON-NFT')
                  ) {
                    quantityNftUsed += Number(item.amount)
                  }
                })
              })
              if (quantityNftUsed + packageList[i]?.amount + amountInCurrentTemplate > quantityInStore) {
                item.isError = true
                // item.amount = ''
                // item.coin_type = ''
                // item.icon = ''
              }
              itemsApply.push(item)
            }
            if (packageList[i]?.item_type === 'TICKET') {
              const ticketResult = recordsByIndex?.find(
                (item: any) => item.ticket_type?.toUpperCase() === packageList[i]?.parent_sub_type?.toUpperCase()
              )
              const item: any = {
                idRandom: randomId(),
                id: ticketResult?.ticket_id ?? randomId(),
                isError: !ticketResult?.ticket_id ? true : false,
                amount: packageList[i]?.amount,
                coin_type: ticketResult ? ticketResult?.ticket_type : packageList[i]?.parent_sub_type,
                type: 'NFT_TICKET',
                inStore: ticketResult ? ticketResult?.quantity - ticketResult?.in_use : 0,
                status: 'DRAFT',
              }
              // Amount item === name => in current template
              let amountInCurrentTemplate = 0
              if (i > 0) {
                const slicedItems = packageList.slice(0, i)
                const listItems = slicedItems.filter((it: any) => it.parent_sub_type === packageList[i]?.parent_sub_type)
                amountInCurrentTemplate = listItems.reduce(
                  (sum: number, item: any) => sum + (item.amount ?? 0),
                  0
                )
              }
              const isPass = Number(item.inStore) >= packageList[i]?.amount + amountInCurrentTemplate
              if (!isPass) {
                item.isError = true
                // const isExis = ticketStore.some(
                //   (ticket: any) =>
                //     ticket.ticket_type === packageList[i]?.parent_sub_type && ticket.quantity > ticket.in_use
                // )
                // if (!isExis) {
                //   item.amount = ''
                //   item.coin_type = ''
                //   item.icon = ''
                // }
              }
              // Check all ranking
              const quantityInStore = Number(item.inStore)
              let quantityNftUsed = 0
              Object.values(finalDataNotCurrentRanking)?.forEach((data: any) => {
                data?.items?.forEach((item: any) => {
                  if (
                    item.type === 'NFT_TICKET' &&
                    item.coin_type?.toUpperCase() === ticketResult?.ticket_type?.toUpperCase()
                  ) {
                    quantityNftUsed += Number(item.amount)
                  }
                })
              })
              if (quantityNftUsed + packageList[i]?.amount + amountInCurrentTemplate > quantityInStore) {
                item.isError = true
                // const isExis = ticketStore.some(
                //   (ticket: any) =>
                //     ticket.ticket_type === packageList[i]?.parent_sub_type && ticket.quantity > ticket.in_use
                // )
                // if (!isExis) {
                //   item.amount = ''
                //   item.coin_type = ''
                //   item.icon = ''
                // }
              }
              itemsApply.push(item)
            }
            if (['HEAD', 'BODY', 'LEG', 'SKIN'].includes(packageList[i]?.item_type)) {
              const listIdsNftsUsed: any[] = []
              Object.values(finalDataNotCurrentRanking)?.forEach((data: any) => {
                data?.items?.forEach((item: any) => {
                  item.type === 'NFT' && listIdsNftsUsed.push(item.id)
                })
              })
              const [error, result]: any = await handleAsyncRequest(
                guildApi.getNftItemsNotUsed(
                  profile.guild_id,
                  { ids: listIdsNftsUsed.concat([...new Set(listIdsCurrentRanking)]) },
                  {
                    rarity: packageList[i]?.rarity_type,
                    type: packageList[i]?.item_type,
                    setName: packageList[i]?.parent_sub_type,
                    limit: packageList[i]?.amount
                  }
                )
              )
              if (error) {
                showToastError('NFT Items over limit')
                return
              }
              if (result.data?.records?.length) {
                const nftAfterRandom = result.data?.records
                nftAfterRandom.map((nftItem: any) => {
                  itemsApply.push({
                    idRandom: randomId(),
                    id: nftItem.id,
                    amount: 1,
                    coin_type: nftItem.name,
                    type: 'NFT',
                    icon: nftItem.img,
                    inStore: 1,
                    status: 'DRAFT',
                  })
                  listIdsNftsUsed.push(nftItem.id)
                  listIdsCurrentRanking.push(nftItem.id)
                })
              } else {
                itemsApply.push({
                  idRandom: randomId(),
                  id: randomId(),
                  amount: 1,
                  coin_type: '',
                  type: 'NFT',
                  isError: true,
                  icon: '',
                  inStore: 0,
                  status: 'DRAFT',
                })
              }
            }
          }
          setItemsRenderByRank(itemsApply)
          asyncFinalData(ranking as string, {
            ...finalData?.[ranking as string],
            template,
            packageId,
            items: itemsApply
          })
          setIsLoadingApply(false)
        }
      }
    }
  }

  const handleSelectTemplate = (val: any) => {
    setTemplate(val.name)
    setPackageId(val.id)
  }

  const handleSave = () => {
    if (finalData) {
      const result: Record<string, any> = {}
      for (const [key, value] of Object.entries(finalData)) {
        const pkg = value as any
        if (!pkg.items || pkg.items.length === 0) continue
        const newItems = pkg.items.map((item: any) => ({
          ...item,
          status: "SAVED",
        }))
        result[key] = {
          ...pkg,
          items: newItems,
        }
      }
      setFinalData(result)
      setFinalDataRoot(result)
      handleSaveSetReward(result)
    } else {
      handleSaveSetReward(finalData)
      setFinalDataRoot(finalData)
    }
    if (!finalData) {
      setTempClear(undefined)
    }
  }

  const handleClear = () => {
    setTempClear(finalData)
    setFinalData(undefined)
    setRanking('1st')
    setTemplate('')
    setItemsRenderByRank([])
    setPackageId(0)
  }

  const handleAdd = () => {
    const emptyItem = {
      type: 'NFT',
      idRandom: randomId(),
      inStore: '',
      id: randomId(),
      coin_type: '',
      amount: '',
      isError: true,
      status: 'DRAFT',
    }
    setItemsRenderByRank(prevs => [...prevs, emptyItem])
    asyncFinalData(ranking as string, {
      ...finalData?.[ranking as string],
      items: [...itemsRenderByRank, emptyItem]
    })
  }

  const handleChangeRanking = (val: any) => {
    if (itemsRenderByRank.length) {
      asyncFinalData(ranking as string, {
        ...finalData?.[ranking as string],
        items: itemsRenderByRank
      })
    }
    setRanking(val.name)
  }

  const handleSelectedMoreItem = (value: any, type: string, ranking: string) => {
    setShowChooseMoreItem({
      isShow: false,
      type: '',
      id: 0
    })
    if (type === 'NFT') {
      const newItemRenderByRank = itemsRenderByRank.map(item =>
        item.id === showChooseMoreItem?.id
          ? { ...item, id: value.id, coin_type: value.name, isError: false, amount: 1, icon: value.img, inStore: 1, }
          : item
      )
      setItemsRenderByRank(newItemRenderByRank)
      asyncFinalData(ranking as string, {
        ...finalData[ranking as string],
        items: newItemRenderByRank
      })
    }
    if (type === 'NON-NFT' || type === 'NON_NFT') {
      // let quantityNonNftUsed = 0
      // Object.values(finalData)?.forEach((data: any) => {
      //   data?.items?.forEach((item: any) => {
      //     if (['NON-NFT', 'NON_NFT'].includes(item.type) && item.coin_type === value.name) {
      //       quantityNonNftUsed += Number(item.amount)
      //     }
      //   })
      // })
      // const isError = quantityNonNftUsed >= value.quantity
      const newItemRenderByRank = itemsRenderByRank.map(item =>
        item.idRandom === showChooseMoreItem?.id
          ? {
              ...item,
              id: value.booster_id,
              coin_type: value.name,
              amount: '',
              icon: value.img,
              inStore: value.quantity - value.in_use
            }
          : item
      )
      setItemsRenderByRank(newItemRenderByRank)
      asyncFinalData(ranking as string, {
        ...finalData[ranking as string],
        items: newItemRenderByRank
      })
    }
  }

  const handleRemoveRow = (randomId: number) => () => {
    const newItems = itemsRenderByRank.filter(prev => prev.idRandom !== randomId)
    setItemsRenderByRank(newItems)
    asyncFinalData(ranking as string, {
      ...finalData[ranking as string],
      items: newItems
    })
  }

  const handleChangeInputAmount = (val: any, itemRender: any) => {
    let value = val
    if (itemRender.type === 'COIN') {
      let quantityNftUsed = 0
      Object.values(finalData)?.forEach((data: any) => {
        data?.items?.forEach((item: any) => {
          if (
            item.type === 'COIN' &&
            item.coin_type?.replace('_NEW', '')?.toUpperCase() ===
              itemRender?.coin_type?.replace('_NEW', '')?.toUpperCase() &&
            item.idRandom !== itemRender.idRandom
          ) {
            quantityNftUsed += Number(item.amount)
          }
        })
      })
      if (Number(val) + quantityNftUsed > getCoinAvailableInStore(itemRender.coin_type)) {
        const result = new BigNumber(getCoinAvailableInStore(itemRender.coin_type)).minus(quantityNftUsed).toNumber()
        if (result < 0) {
          value = 0
        } else {
          value = getOnlyDecimal(String(truncateDecimal(result)), NUMBER.NUM_2147483647)
        }
      } else {
        value = getOnlyDecimal(String(value), NUMBER.NUM_2147483647)
      }
    }

    if (itemRender.type === 'NON_NFT' || itemRender.type === 'NON-NFT') {
      let quantityNftUsed = 0
      Object.values(finalData)?.forEach((data: any) => {
        data?.items?.forEach((item: any) => {
          if (
            ['NON_NFT', 'NON-NFT'].includes(item.type) &&
            item.coin_type?.toUpperCase() === itemRender.coin_type?.toUpperCase() &&
            item.idRandom !== itemRender.idRandom
          ) {
            quantityNftUsed += Number(item.amount ?? 0)
          }
        })
      })
      if (Number(val) + quantityNftUsed > getBoosterAvailableInStore(itemRender.coin_type)) {
        if (getBoosterAvailableInStore(itemRender.coin_type) - quantityNftUsed < 0) {
          value = 0
        } else {
          value = getBoosterAvailableInStore(itemRender.coin_type) - quantityNftUsed
        }
      }
    }

    if (itemRender.type === 'NFT_TICKET') {
      let quantityNftUsed = 0
      Object.values(finalData)?.forEach((data: any) => {
        data?.items?.forEach((item: any) => {
          if (
            ['NFT_TICKET'].includes(item.type) &&
            item.coin_type?.toUpperCase() === itemRender.coin_type?.toUpperCase() &&
            item.idRandom !== itemRender.idRandom
          ) {
            quantityNftUsed += Number(item.amount ?? 0)
          }
        })
      })
      if (Number(val) + quantityNftUsed > getTicketAvailableInStore(itemRender.coin_type)) {
        if (getTicketAvailableInStore(itemRender.coin_type) - quantityNftUsed < 0) {
          value = 0
        } else {
          value = getTicketAvailableInStore(itemRender.coin_type) - quantityNftUsed
        }
      }
    }
    const newItems = itemsRenderByRank.map(item =>
      item.idRandom === itemRender.idRandom ? { ...item, amount: value, isError: !Number(value) } : item
    )
    setItemsRenderByRank(newItems)
    asyncFinalData(ranking as string, {
      ...finalData[ranking as string],
      items: newItems
    })
  }

  const _handleKeyDownPrize = (e: any, type: string) => {
    const key = e.key
    const allowedKeys =
      type === 'COIN'
        ? ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', '.', 'Home', 'End']
        : ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End']
    const isNumberKey = key >= '0' && key <= '9'
    const isAllowedKey = allowedKeys.includes(key)
    if (!isNumberKey && !isAllowedKey) {
      e.preventDefault()
    }
    if (key === '.' && (e.currentTarget.value.includes('.') || e.currentTarget.selectionStart === 0)) {
      e.preventDefault()
    }
  }

  const renderOptionCoinTicket = (type: string, value: string, amount: string) => {
    if (type === 'COIN') {
      const isExis = optionsCoin.some((coin) => coin.name === value)
      if ((amount || value) && !isExis) {
        const coin: any = coinStore.find((coin: any) => coin.coin_type?.replace('_NEW', '') === value)
        return [
          ...optionsCoin,
          {
            isAcitve: false,
            name: value.replace('_NEW', ''),
            icon: <img className='mr-2' alt='Merah' src={getImgByKey(value)} width={25} />,
            inStore: coin ? coin.quantity - coin.in_use : 0,
          }
        ]
      } else {
        return optionsCoin
      }
    }

    if (type === 'NFT_TICKET' || type === 'NFT TICKET') {
      const isExis = optionsTicket.some((ticket) => ticket.name === value)
      if ((amount || value) && !isExis) {
        const ticket: any = ticketStore.find((ticket: any) => ticket.ticket_type === value)
        return [
          ...optionsTicket,
          {
            isAcitve: false,
            name: value,
            icon: <img className='mr-2' alt='Merah' src={getImgByKey(value)} width={25} />,
            inStore: ticket ? ticket.quantity - ticket.in_use : 0,
          }
        ]
      } else {
        return optionsTicket
      }
    }
  }

  const handleClose = () => {
    // if (finalData) {
    //   const result: Record<string, any> = {}
    //   for (const [key, value] of Object.entries(finalData)) {
    //     const pkg = value as any
    //     const newItems = pkg.items.filter((item: any) => item.status === "SAVED")
    //     if (newItems.length > 0) {
    //       result[key] = {
    //         ...pkg,
    //         items: newItems,
    //       }
    //     }
    //   }
    //   setFinalData(result)
    // }
    onCloseButtonClick?.()
  }

  return (
    <Modal>
      {isLoading ? (
        <Loading />
      ) : (
        <ModalSetRewardTemplateStyled>
        <div className='set-reward-template-modal'>
          <button className='close-btn p-0 position-absolute' role='button' onClick={handleClose}>
            <img src={CLOSE_BTN} alt='close' />
          </button>
          <div className='title-reward-template-container'>
            <div className={`color-primary`}>{t(`${PROFILE_MESSAGE}.setItemRewards`)}</div>
            <img src={TWO_LINE} alt='' />
          </div>
          <div className='reward-template-container'>
            <div className='apply-action'>
              <div className='box-select'>
                <div className='title-select-box'>RANKING</div>
                <SelectCustomCreateRace
                  dataSelect={rankingFilters}
                  nameSelect={ranking}
                  onSelected={handleChangeRanking}
                />
              </div>
              <div className='box-select'>
                <div className='title-select-box'>REWARD TEMPLATE</div>
                <SelectCustomCreateRace
                  dataSelect={templateFilters}
                  nameSelect={template}
                  onSelected={handleSelectTemplate}
                />
              </div>
              <Button
                buttonName={<div>{t(`${GUILD_MESSAGE}.apply`)}</div>}
                onClickButton={handleApply}
                width={147}
                classNames='btn-add'
                disabled={!template}
                isLoading={isLoadingApply}
              />
            </div>
            <div className='row line__guild--gradiant'>
              <img src={LINE_GUILD_GRADIENT} />
            </div>
            <div className='items-reward-container'>
              <div className='rendered-items border-styled'>
                <div className='item-inner'>
                  <div className='view-item'>
                    <div className='column-title'>Type</div>
                  </div>
                  <div className='view-item'>
                    <div className='column-title'>Name</div>
                  </div>
                  <div className='view-item'>
                    <div className='column-title'>Available</div>
                  </div>
                  <div className='view-item'>
                    <div className='column-title'>Amount</div>
                  </div>
                  <div className='view-item'>
                    <div className='column-title' />
                  </div>
                </div>
              </div>
              <div className='rendered-items mt-32'>
                {itemsRenderByRank.map(itemRender => (
                  <div key={itemRender.idRandom}>
                    <div className={`item-inner ${itemRender.isError ? 'border-error' : ''}`}>
                      <div className='view-item'>
                        <SelectCustomCreateRace
                          dataSelect={optionItemType}
                          nameSelect={itemTypeConvertedName(itemRender.type)}
                          onSelected={(val: any) => {
                            const newItems = itemsRenderByRank.map(item =>
                              item.idRandom === itemRender.idRandom
                                ? { ...item, type: val.value, coin_type: '', amount: '', isError: true, inStore: '', icon: '', id: '' }
                                : item
                            )
                            setItemsRenderByRank(newItems)
                            asyncFinalData(ranking as string, {
                              ...finalData[ranking as string],
                              items: newItems
                            })
                          }}
                        />
                      </div>
                      <div className='view-item'>
                        {['COIN', 'NFT_TICKET', 'NFT TICKET'].includes(itemRender.type) ? (
                          <SelectCustomCreateRace
                            dataSelect={renderOptionCoinTicket(itemRender.type, itemRender.coin_type, itemRender.amount)}
                            nameSelect={itemRender.coin_type}
                            onSelected={(val: any) => {
                              const newItems = itemsRenderByRank.map(item =>
                                item.idRandom === itemRender.idRandom
                                  ? { ...item, coin_type: val.name, amount: '', inStore: val.inStore, isError: true }
                                  : item
                              )
                              setItemsRenderByRank(newItems)
                              asyncFinalData(ranking as string, {
                                ...finalData[ranking as string],
                                items: newItems
                              })
                            }}
                            isShowIcon
                          />
                        ) : (
                          <SelectCustomGuildRace
                            dataSelect={optionsName}
                            type={itemRender.type}
                            nameSelect={itemRender.coin_type}
                            icon={itemRender.icon}
                            onSelected={(val: any) => {
                              const newItems = itemsRenderByRank.map(item =>
                                item.idRandom === itemRender.idRandom
                                  ? {
                                      ...item,
                                      coin_type: val.name,
                                      amount: itemRender.type === 'NFT' ? '1' : '',
                                      id: val.id,
                                      isError: false
                                    }
                                  : item
                              )
                              setItemsRenderByRank(newItems)
                              asyncFinalData(ranking as string, {
                                ...finalData[ranking as string],
                                items: newItems
                              })
                            }}
                            onClickSelect={(val: any) => {
                              if (val.type === 'DROPDOWN') {
                                const options = val.options.map((otp: any) => ({
                                  ...otp,
                                  id: itemRender.type === 'NFT' ? otp.id : otp.booster_id,
                                  name: otp.name,
                                  value: itemRender.type === 'NFT' ? otp.id : otp.booster_id
                                }))
                                if (itemRender.type === 'NFT') {
                                  const listNftsUsed: any[] = []
                                  Object.values(finalData)?.forEach((data: any) => {
                                    data.items.forEach((item: any) => {
                                      item.type === 'NFT' && listNftsUsed.push(item.coin_type)
                                    })
                                  })
                                  const listCanUse = options.filter((itm: any) => !listNftsUsed.includes(itm.name))
                                  setOptionsName(listCanUse)
                                } else {
                                  const listNonNftUsed: any[] = []
                                  Object.values(finalData)?.forEach((data: any) => {
                                    data.items.forEach((item: any) => {
                                      if (item.type === 'NON_NFT' || item.type === 'NON-NFT') {
                                        listNonNftUsed.push(item)
                                      }
                                    })
                                  })
                                  const listCanUse = options.filter((itm: any) => {
                                    if (itm.quantity - itm.in_use > 0) {
                                      const inStore = itm.quantity - itm.in_use
                                      const amountUsed = listNonNftUsed.reduce((sum, item) => {
                                        return item.coin_type === itm.name ? sum + Number(item.amount) : sum
                                      }, 0)
                                      if (inStore > amountUsed) {
                                        return itm
                                      }
                                    }
                                  })
                                  setOptionsName(listCanUse)
                                }
                              }
                              if (val.type === 'MODAL') {
                                setShowChooseMoreItem({
                                  isShow: true,
                                  type: itemRender.type,
                                  id: itemRender.type === 'NFT' ? itemRender.id : itemRender.idRandom
                                })
                              }
                            }}
                          />
                        )}
                      </div>
                      <div className='view-item'>
                        <InputPrizePool
                          type='text'
                          value={itemRender.inStore}
                          maxLength={16}
                          heigth={40}
                          disabled
                          customClass='input-disabled'
                        />
                      </div>
                      <div className='view-item'>
                        <InputPrizePool
                          type='text'
                          value={itemRender.amount}
                          onChange={val => {
                            handleChangeInputAmount(val, itemRender)
                          }}
                          maxLength={16}
                          heigth={40}
                          disabled={itemRender.type === 'NFT' || !itemRender.coin_type}
                          customClass={`${itemRender.isError ? 'error-input' : ''} ${
                            itemRender.type === 'NFT' ? 'input-disabled' : ''
                          }`}
                          onKeyDown={e => _handleKeyDownPrize(e, itemRender.type)}
                        />
                      </div>
                      <div className='view-item icon-delete'>
                        <img
                          style={{ cursor: 'pointer' }}
                          onClick={handleRemoveRow(itemRender.idRandom)}
                          src={DELETE}
                          alt='close'
                          width={24}
                          height={24}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className='actions'>
              {itemsRenderByRank.length < 12 ? (
                <div>
                  <Button
                    disabled={itemsRenderByRank.length >= 12}
                    buttonName={t(`${GUILD_MESSAGE}.add`)}
                    onClickButton={handleAdd}
                    width={147}
                    type='btnSelectAll'
                  />
                </div>
              ) : (
                <div style={{ height: '45px' }} />
              )}
              <div className='clear-save-action'>
                <Button
                  type='btnCancel'
                  buttonName={t(`${GUILD_MESSAGE}.clear`)}
                  onClickButton={handleClear}
                  width={147}
                />
                <Button
                  disabled={isDisabledSave}
                  buttonName={t(`${GUILD_MESSAGE}.save`)}
                  onClickButton={handleSave}
                  width={147}
                />
              </div>
            </div>
          </div>
          {showChooseMoreItem?.isShow && (
            <ChooseMoreItemReward
              onCloseButtonClick={() =>
                setShowChooseMoreItem({
                  isShow: false,
                  type: '',
                  id: 0
                })
              }
              onSaveClick={handleSelectedMoreItem}
              type={showChooseMoreItem.type}
              finalData={finalData}
              ranking={ranking}
            />
          )}
        </div>
      </ModalSetRewardTemplateStyled>
      )}
    </Modal>
  )
}

export default ModalSetRewardTemplate
